import React from 'react'

import { InjectedIntlProps, injectIntl } from 'react-intl'

import { SubmissionChannels } from '@enums'
import { IChannel } from '@store/campaigns'
import Theme from '@theme'
import { BlockText } from '../Block/Block.styled'

interface IProps extends InjectedIntlProps {
  selectedChannels: ReadonlyArray<IChannel>
}

const channelOrder = [
  SubmissionChannels.Instagram,
  SubmissionChannels.TikTok,
  SubmissionChannels.Pinterest,
  SubmissionChannels.X,
  SubmissionChannels.Snapchat,
  SubmissionChannels.YouTube,
  SubmissionChannels.Facebook,
]

const CampaignPreviewInfluencerRequirementsChannels: React.FC<IProps> = ({
  selectedChannels,
  intl,
}) => {
  return (
    <BlockText small color={Theme.grey800Color} capitalize>
      {[...selectedChannels]
        .sort((a, b) => channelOrder.indexOf(a.name) - channelOrder.indexOf(b.name))
        .map((channel) =>
          intl.formatMessage({
            id: `campaign.preview.channels.${channel.name}`,
            defaultMessage: channel.name,
          }),
        )
        .join(', ')}
    </BlockText>
  )
}

export default injectIntl(CampaignPreviewInfluencerRequirementsChannels)
